import { useContext } from 'react';

import { NotificationsContext } from '../notifications';

export const useNotifications = () => useContext(NotificationsContext);
